import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/n360/AppShell";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Directory from "@/pages/Directory";
import ProfileView from "@/pages/ProfileView";
import ProfileBuilder from "@/pages/ProfileBuilder";
import Referrals from "@/pages/Referrals";
import IntelligenceDesk from "@/pages/IntelligenceDesk";
import AdminPanel from "@/pages/AdminPanel";

function Loading() {
  return (
    <div className="n360-app-bg grid place-items-center min-h-screen">
      <div className="font-display text-2xl text-[#2f5561] animate-pulse">N<span className="gold-text">360</span></div>
    </div>
  );
}

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/app" replace />;
  return <AppShell>{children}</AppShell>;
}

function GuestOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="dark" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
            <Route path="/signup" element={<GuestOnly><Signup /></GuestOnly>} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/app/directory" element={<Protected><Directory /></Protected>} />
            <Route path="/app/profile" element={<Protected><ProfileBuilder /></Protected>} />
            <Route path="/app/member/:profileId" element={<Protected><ProfileView /></Protected>} />
            <Route path="/app/referrals" element={<Protected><Referrals /></Protected>} />
            <Route path="/app/intelligence" element={<Protected roles={["intelligence_contributor", "field_associate", "admin"]}><IntelligenceDesk /></Protected>} />
            <Route path="/app/admin" element={<Protected roles={["admin"]}><AdminPanel /></Protected>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
